import React, { useState, useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  flexRender,
} from "@tanstack/react-table";
import { Table } from "react-bootstrap";
import { useAddNewStore } from "../../../store/add_new_store";

const SelectedPanels = () => {
  const { selectedPanels } = useAddNewStore();

  const columns = useMemo(
    () => [
      { accessorKey: "cloudId", header: "Cloud ID" },
      { accessorKey: "panelName", header: "Panel Name" },
    ],
    []
  );

  const table = useReactTable({
    data: selectedPanels,
    columns,
    state: {},
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  return (
    <>
      <Table bordered variant="info">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  className="align-middle"
                  style={{ backgroundColor: "white" }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default SelectedPanels;
